<template>
  <div style="min-height: 750px;">
    <div class="group_2">
         <div class="box_left" v-if="activeName=='first'">
          <div  v-if="classShow">
            <div class="subjects" v-if="!isDropdownOpen">
              <div class="dropdown">
                <div class="subText">{{ subInfo.trainingSubject }}</div>
                <div class="qh" @click="toggleDropdown">
                  <img src="../../../assets/images/qie.png" alt="" />
                  <div class="km">切换科目</div>
                </div>
              </div>
            </div>
            <div class="subjects2" v-if="isDropdownOpen">
              <div class="sub">
                <div class="dropdown">
                  <div class="subText" style="color: #3172f6">
                    {{ subInfo.trainingSubject }}
                  </div>
                  <div class="qh" @click="toggleDropdown">
                    <img src="../../../assets/images/qie.png" alt="" />
                    <div class="km">切换科目</div>
                  </div>
                </div>
                <div class="dropdown_item" v-if="dropdownList.length > 0">
                  <div class="subItem" v-for="item in dropdownList" :key="item.id" @click="handleKm(item.trainingSubjectId)">
                    {{ item.trainingSubject || '' }}
                  </div>
                </div>
                <div class="dropdown_item" v-else>
                  <div class="subItem" style="color: #999; font-size: 14px">暂无更多科目~</div>
                </div>
              </div>
            </div>
          </div>

          <div class="subjects" v-else>
            <div class="dropdown" style="width: 150px">
              <div class="qh" @click="handleClass">
                <div class="km" style="color: #3172f6">暂无科目，去报名</div>
              </div>
            </div>
          </div>
        </div>
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="理论学习" name="first">
          <div v-if="userCourseList.length>0">
            <div style="display: flex; flex-wrap: wrap">
              <div class="studyList" v-for="item in userCourseList" :key="item.id" @click="handleChapter(item)">
                <div class="studyTitle">{{ item.courseName }}</div>
                <div class="hours">{{ item.ccreditHour }}学时</div>
                <div class="tag" style="color: #888; background: #e9e9e9" v-if="item.studyStatus == '03'">已完成</div>
                <div class="tag" v-if="item.studyStatus == '01'">未学习</div>
                <div class="tag" v-if="item.studyStatus == '02'">学习中</div>
              </div>
            </div>
            <div style="display: flex; justify-content: center; margin-top: 20px">
              <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="pageNum"
                :page-sizes="[12, 24, 48, 100]"
                :page-size="pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="total"
              >
              </el-pagination>
            </div>
          </div>
             <div v-else style="display: flex; align-items: center; justify-content: center; height: 534px; flex-direction: column">
            <img src="../../../assets/images/image 61@2x (1).png" alt="" style="width: 180px; height: 180px" />
            <div style="font-weight: 400; font-size: 14px; color: #999999">
              暂未报名课程，立即<span style="color: #3172f6;cursor: pointer;" @click="handleClass">前往报名</span>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="实训班信息" name="second">
          <div  v-if="offlineClassInfoVoList.length>0">
            <div class="classList" v-for="v in offlineClassInfoVoList" :key="v.offlineClassId">
              <div class="cover">
                <img :src="v.classImage" alt="" v-if="v.classImage != '' && v.classImage != null" />
                <img src="../../../assets/images/noImg.jpg" alt="" v-else />
              </div>
              <div class="info">
                <div class="infoText_1">
                  {{ v.className }}
                </div>
                <div class="infoText_2">
                  <span style="width: 142px; display: inline-block">报名时间：{{ v.auditTime }}</span
                  ><span style="margin-left: 40px">实训班联系电话：{{ v.phone }}</span>
                </div>
                <div class="infoText_2">培训地址：{{ v.offlineClassSite }}</div>
              </div>
              <div class="btn" @click="handleDetil(v)">课程详情</div>
            </div>
          </div>
            <div v-else style="display: flex; align-items: center; justify-content: center; height: 534px; flex-direction: column">
            <img src="../../../assets/images/image 61@2x (1).png" alt="" style="width: 180px; height: 180px" />
            <div style="font-weight: 400; font-size: 14px; color: #999999">
              暂未报名课程，立即<span style="color: #3172f6;cursor: pointer;" @click="handleClass">前往报名</span>
            </div>
          </div>

        </el-tab-pane>
      </el-tabs>
    </div>
    <!-- //章节信息 -->
    <div class="group_5" v-if="showChapter">
      <el-tabs v-model="activeName1">
        <el-tab-pane label="知识点课程" name="first1">
          <div style="display: flex; flex-wrap: wrap">
            <div class="chapterList" v-for="h in getCourseinfo" :key="h.chapterId" @click="handleVide(h.cwId)">
              <div class="chapterCover">
                <div class="chapterTitle">{{ h.chapterTitle }}</div>
              </div>
              <div class="chapterBox">
                <div class="chtext">{{ h.chapterTitle }}</div>
                <div class="chtext_1" v-if="h.studyStatus == '01'">未学习</div>
                <div class="chtext_1" v-if="h.studyStatus == '03'">已完成</div>
                <div class="chtext_1" v-if="h.studyStatus == '02'">学习中</div>
              </div>
            </div>
          </div>
          <div style="display: flex; justify-content: center; margin-top: 20px">
            <el-pagination
              @size-change="handleSizeChange1"
              @current-change="handleCurrentChange1"
              :current-page="pageNum1"
              :page-sizes="[10, 20, 40, 100]"
              :page-size="pageSize1"
              layout="total, sizes, prev, pager, next, jumper"
              :total="total1"
            >
            </el-pagination>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
    <!-- 课程详情 -->
    <el-dialog :visible.sync="centerDialogVisible" width="40%" center>
      <img :src="pic" alt="" style="width: 100%" />
    </el-dialog>
    <NoticeDialog :visible.sync="dialogTableVisible" />
  </div>
</template>
<script>
import NoticeDialog from '../../component/NoticeDialog.vue';
import { getClassLearnInfo, getResChapterList } from '../../../api/study';
// 引入echart
// import * as echarts from 'echarts';

export default {
  components: {
    NoticeDialog
  },
  data() {
    return {
      activeName: 'first',
      dialogTableVisible: false,
      trainSubjectId: '',
      pageNum: 1,
      activeName1: 'first1',
      pageSize: 12,
      subInfo: {}, //科目信息
      classShow: false, //是否有课
      isCourseUpdate: '', //01 表示课程没更新 02 表示课程有更新
      isDropdownOpen: false,
      dropdownList: [], //下拉科目
      offlineClassInfoVoList: [], //实训班级
      userCourseList: [], //理论学习
      total: 0,
      centerDialogVisible: false,
      pic: '', //课程图片详情
      classCreditHour: 0, //目标学时
      finishCredit: 0, //完成学时
      completionRate: 0, //学习进度
      showChapter: false, //是否展示章节
      pageNum1: 1,
      pageSize1: 10,
      total1: 0,
      getCourseinfo: [],
      currentCourseId: '',
      onlineClassId: '',
      cassid: '',
      courseId: ''
    };
  },
  computed: {},
  watch: {},
  created() {
    this.getCourse(this.trainSubjectId);
     window.scrollTo(0, 0);


  },
  methods: {
    //去通知中心
    getNote() {
      this.dialogTableVisible = true;
    },
    //去订单管理
    getOrder() {
      this.$emit('update:tabIndex', 3);
    },
    //去个人信息
    getUserInfo() {
      this.$emit('update:tabIndex', 4);
    },
    //去课程学习
    getClass() {
      this.$emit('update:tabIndex', 8);
    },
    //去报名
    handleClass() {
      this.$router.push({ path: '/courseSelection' });
    },
    // 切换下拉菜单
    toggleDropdown() {
      this.isDropdownOpen = !this.isDropdownOpen;
    },
    //查看实训班
    gotoClass() {
      this.activeName = 'second';
    },
    //课程详情
    handleDetil(v) {
      this.pic = v.offlineCourse;
      this.centerDialogVisible = true;
    },
    //切换科目
    handleKm(id) {
      this.trainSubjectId = id;
      this.getCourse(id);
      this.isDropdownOpen = !this.isDropdownOpen;
      this.showChapter = false;
    },
    //分页事件
    handleSizeChange(val) {
      this.pageSize = val;
      this.pageNum = 1;
      this.getCourse(this.trainSubjectId);
    },
    //页码变化事件
    handleCurrentChange(val) {
      this.pageNum = val;
      this.getCourse(this.trainSubjectId);
    },
    handleSizeChange1(val) {
      this.pageSize1 = val;
      this.pageNum1 = 1;
      getResChapterList({
        courseId: this.currentCourseId,
        pageNum: this.pageNum1,
        pageSize: this.pageSize1,
        classId: this.onlineClassId
      }).then(res => {
        this.getCourseinfo = res.data.rows;
        this.total1 = res.data.total;
      });
    },
    handleCurrentChange1(val) {
      this.pageNum1 = val;
      getResChapterList({
        courseId: this.currentCourseId,
        pageNum: this.pageNum1,
        pageSize: this.pageSize1,
        classId: this.onlineClassId
      }).then(res => {
        this.getCourseinfo = res.data.rows;
        this.total1 = res.data.total;
      });
    },
    //获取报名课程信息
    getCourse(id) {
      getClassLearnInfo({
        trainSubjectId: id,
        pageNum: this.pageNum,
        pageSize: this.pageSize
      }).then(res => {
        if (res.data.data && res.data.data != '0') {
          this.classShow = true;
          this.subInfo = res.data.data;
          this.dropdownList = res.data.data.trainingSubjectList || [];
          this.offlineClassInfoVoList = res.data.data.offlineClassInfoVoList;
          this.total = res.data.data.userCourseList.total;
          this.userCourseList = res.data.data.userCourseList.rows;
          this.isCourseUpdate = res.data.data.isCourseUpdate;
          this.classCreditHour = res.data.data.classCreditHour;
          this.finishCredit = res.data.data.finishCredit;
          this.completionRate = res.data.data.completionRate;
          if (this.isCourseUpdate == '02') {
            this.$alert('您的班级课程有更新，请及时查看学习！', '温馨提示', {
              confirmButtonText: '确定',
              callback: action => {}
            });
          }
        
        }
      });
    },
    //去看视频页面
    handleVide(item) {
      this.$router.push({ path: '/video', query: { cwId: item,
         classId: this.cassid,courseId:this.courseId } });
    },

    //章节信息
    handleChapter(item) {
      this.pageNum1 = 1;
      this.showChapter = true;
      this.currentCourseId = item.courseId;
      this.onlineClassId = this.subInfo.onlineClassId;
      getResChapterList({ courseId: item.courseId, pageNum: this.pageNum1, pageSize: this.pageSize1, classId: this.onlineClassId }).then(
        res => {
          this.getCourseinfo = res.data.rows;
          this.cassid = res.data.data.classId;
          this.courseId = res.data.data.courseId;
          this.total1 = res.data.total;
        }
      );
          setTimeout(() => {
        this.$nextTick(() => {
          window.scrollBy({
            top: 900,
            behavior: 'smooth'
          });
        });
      }, 300);
    },
    handleClick() {
      this.showChapter = false;
    }
  },

  mounted() {
   
  },
  beforeCreate() {},
  beforeMount() {}
};
</script>
<style lang="less" scoped>
    .box_left {
      width: 400px;
      position: relative;
      .subjects {
        position: absolute;
        z-index:200;
        top: -8px;
        left: 0;
        .text_4 {
          font-family: PingFang SC, PingFang SC;
          font-weight: 500;
          font-size: 14px;
          color: #999999;
        }
        .dropdown {
          padding: 11px 12px;
          width: 332px;
          height: 44px;
          background: #f4f6fa;
          border-radius: 4px 4px 4px 4px;
          border: 1px solid #f4f6fa;
          //margin-top: 8px;
          //margin-bottom: 20px;
          display: flex;
          justify-content: space-between;
          .subText {
            font-family: PingFang SC, PingFang SC;
            font-weight: 500;
            font-size: 16px;
            color: #333333;
            width: 180px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
        }

        .qh {
          display: flex;
          align-items: center;
          img {
            width: 16px;
            margin-right: 2px;
            height: 16px;
          }
        }
        .km {
          font-family: PingFang SC, PingFang SC;
          font-weight: 500;
          font-size: 14px;
          color: #666666;
          cursor: pointer;
        }
      }
    }

.group_2 {
  width: 1188px;
position: relative;
  background: #ffffff;
  border-radius: 4px 4px 4px 4px;
  padding: 20px 24px;
  // min-height: 448px;
  .studyList:nth-child(4n) {
    margin-right: 0 !important;
  }
  .tag {
    width: 68px;
    height: 28px;
    background: rgba(124, 167, 255, 0.2);
    border-radius: 14px 0px 4px 0px;
    position: absolute;
    bottom: 0;
    right: 0;
    text-align: center;
    line-height: 28px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: #3172f6;
  }
  .studyList {
    position: relative;
    margin-right: 20px;
    width: 270px;
    cursor: pointer;
    height: 80px;
    background: #f2f6ff;
    border-radius: 4px 4px 4px 4px;
    padding: 15px 20px;
    margin-bottom: 20px;
  }
  .studyTitle {
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 16px;
    color: #333333;
    width: 200px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .hours {
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: #999999;
    margin-top: 10px;
  }
  .classList {
    margin-bottom: 24px;
    display: flex;
    align-items: center;
    .cover img {
      width: 120px;
      height: 96px;
      border-radius: 4px 4px 4px 4px;
    }
    .info {
      width: 900px;
      margin-left: 12px;
    }
    .btn {
      width: 101px;
      height: 36px;
      background: #ffffff;
      border-radius: 4px 4px 4px 4px;
      border: 1px solid #707070;
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 12px;
      color: #666666;
      text-align: center;
      line-height: 36px;
      cursor: pointer;
    }
    .infoText_1 {
      margin-top: 7px;
      width: 700px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      margin-bottom: 12px;
      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      font-size: 16px;
      color: #333333;
    }
    .infoText_2 {
      width: 600px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      margin-bottom: 12px;
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 14px;
      color: #666666;
    }
  }
}
.group_5 {
  margin-top: 12px;
  padding: 20px 24px;
  width: 1188px;
  height: auto;
  background: #ffffff;
  border-radius: 4px 4px 4px 4px;
  .chapterList:nth-child(5n) {
    margin-right: 0 !important;
  }
  .chapterList {
    width: 220px;
    margin-right: 10px;
    margin-bottom: 20px;
    height: 167px;
    background: #ffffff;
    box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.08);
    border-radius: 4px 4px 4px 4px;
    cursor: pointer;
    .chapterCover {
      width: 220px;
      height: 100px;
      background-image: url('../../../assets/images/chapterBg.png');
      background-size: 100%;
      border-radius: 4px 0px 0px 4px;
      padding: 28px 15px;
      .chapterTitle {
        width: 115px;
        height: 44px;
        font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
        font-weight: bold;
        font-size: 16px;
        color: #333333;
        display: -webkit-box; /* 使用弹性盒模型 */
        -webkit-box-orient: vertical; /* 垂直排列子元素 */
        -webkit-line-clamp: 2; /* 限制显示的行数为2行 */
        overflow: hidden;
      }
    }
    .chapterBox {
      padding: 10px;
      .chtext {
        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        font-size: 14px;
        color: #333333;
        width: 180px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        margin-bottom: 8px;
      }
      .chtext_1 {
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        font-size: 12px;
        color: #999999;
      }
    }
  }
}
    .subjects2 {
      position: absolute;
      top: -8px;
      z-index: 200;
      left: 0;
      .text_4 {
        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        font-size: 14px;
        color: #999999;
      }
      .dropdown {
        background: #f4f6fa;
        border-radius: 4px 4px 4px 4px;
        border: 1px solid #f4f6fa;
        display: flex;
        justify-content: space-between;
      }
      .sub {
        margin-top: 8px;
        padding: 11px 12px;
        width: 332px;
        background: #f4f6fa;
        box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.2);
        border-radius: 4px 4px 4px 4px;
        border: 1px solid #f4f6fa;
      }
      .subText {
        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        font-size: 16px;
        color: #333333;
        width: 180px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .qh {
        display: flex;
        align-items: center;
        img {
          width: 16px;
          margin-right: 2px;
          height: 16px;
        }
      }
      .km {
        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        font-size: 14px;
        color: #666666;
        cursor: pointer;
      }
      .subItem {
        margin-bottom: 16px;
        width: 300px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        font-size: 16px;
        color: #333333;
        cursor: pointer;
      }
      .dropdown_item {
        margin-top: 16px;
        border-radius: 4px 4px 4px 4px;
      }
    }
::v-deep {
  .el-tabs__item {
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 16px;
  }
  .el-tabs__nav-scroll{
display: flex;
justify-content: center;
  }
}
</style>
